import {get} from 'lodash';

import {SCOPES} from '@app/constants';
import {DATA, LOADING} from '../../constants';
import {
    GET_LOGGED_IN_USER,
    LOGIN,
    REFRESH,
    TOKEN,
    USER_DATA_STORAGE_KEY,
    GET_USERS,
} from '../constants';
import {getCookie} from '@app/utils/auth';

export const isLoginFetchingSelector = (state) => {
    return get(state, [LOGIN, LOADING]) === true;
};

export const tokenSelector = () => {
    return get(JSON.parse(getCookie(USER_DATA_STORAGE_KEY)), TOKEN);
    /* THIS IS AN EXPIRED TOKEN TO TEST UNAUTHORIZED REQUESTS
        return 'eyJhbGciOiJSUzUxMiIsInR5cCI6IkpXVCJ9.eyJhcHBJRCI6ImRhc2hib2FyZCIsImF1ZCI6Im1pbmQuc2V0dGluZ3MsbWluZC5rbm93bGVkZ2UucmVhZCxtaW5kLmtub3dsZWRnZS53cml0ZSIsImV4cCI6MTY0MjcxNDIzMSwiaWF0IjoxNjQyNzAzNDMxLCJpc3MiOiJrYXJlLm1pbmQiLCJqdGkiOiJmZWQyY2YzYi1lNmY1LTQwYTQtOTVmOS0wZTU3Yjg2MTdmZjMiLCJuYmYiOjE2NDI3MDM0MzEsIm9yZ0lEIjoib3JnXzEyYjE0N2Q5LTAyZjEtNGJhNi1iNmI1LTBhNjM5NGJlZjdhMCIsInN1YiI6InVzZXIuYWNjZXNzIiwidXNlcklEIjoidXNyX2EwMjU2YWNjLTNlYzktNDc1Ny05YjFmLWUyM2Y3OWNjNWUyMSJ9.u934ieDUc6oIpQzvcyXJu290qKz2Ov5tL7M2i9LpZuL-kADDjMYcKua_LG2joPvmo7l6HRl4oI-oIjV3U0mgsH1q_k4oMWMam_JtmHP8CEc_DzTUZ282tyCbMN-juBNn5u7idnbpMOr3cPROWqUfqHVdR9pgH0dcsdllI7cnePOgDGH6Q5w2zztwW1X5rTwqTEfhINjBuQHXwz7hEfOmgkXq0JOtCLXqnjm49F-vuo6MgN5sdWEnAVaLrT7R3ZmEp9HHzVQPHW11zZkItWlP0HXYTQcgkkjAkEPGYqOQ-_-GGXk24OoA3bycofsUhA0cQ-BrovYkV-GMqVl4CBJHhTiGv9Ccyr_W9L8NmAQlpwJ0EQPW9FbZjMaWsLq1k8CH8K01MDf2YxqjSCWgBDtJ1hD1urdsNAohndAvMpkr4qIfqhV9jCbRoQD9ki1O5vohFIHbBHFmWqnR_Bzthq-8Js5xDTTYdEeJocfyhVsoWApJ-k48mUfjgO3JX2xsNhqB8LwEJ38qIdNImrHNZYidFJHBJjTjCEbYWHDDQkO4Oog_0Dhq6vkSJlMxHlkTK-8qjugxtnaIL4ugmKd2W1VcT-EetSZY5WkTFqoEttcTkGPeXs4y1cSxZm6sWQN_fhZje2-Byy1KRLkU12MXj2wYbckuWkkJKlRRiA81qTzyGN0","refresh_token":"eyJhbGciOiJSUzUxMiIsInR5cCI6IkpXVCJ9.eyJhcHBJRCI6ImRhc2hib2FyZCIsImF1ZCI6Im1pbmQuc2V0dGluZ3MsbWluZC5rbm93bGVkZ2UucmVhZCxtaW5kLmtub3dsZWRnZS53cml0ZSIsImV4cCI6MTY0NTI5NTQzMSwiaWF0IjoxNjQyNzAzNDMxLCJpc3MiOiJrYXJlLm1pbmQiLCJqdGkiOiI3MGNmNDhmNy0wMjBmLTQ1MjEtOTY3ZC04NzcyYjQ0ZDRjMTkiLCJuYmYiOjE2NDI3MDM0MzEsIm9yZ0lEIjoib3JnXzEyYjE0N2Q5LTAyZjEtNGJhNi1iNmI1LTBhNjM5NGJlZjdhMCIsInN1YiI6InVzZXIucmVmcmVzaCIsInVzZXJJRCI6InVzcl9hMDI1NmFjYy0zZWM5LTQ3NTctOWIxZi1lMjNmNzljYzVlMjEifQ.r_H4cg8PEiGc1vB39fSzotBNJ9CIbo-FYfWIjM2irH2amRcYufzAwWsKo_YukQgeqfIBTzMFgSDLC-VRLRlAaESDbDWGFqc-iA_m0oOlrLfNncFacUB-uNwIOOCEARfxq5XGHkRGxx63-aBXhzR6CbyX5Kk2piztcMAEBKwLJl7LasQVLoI2WngrXoxQFUdlyWt_W11OZ4twzw9aMrlNzIvX2WDQErtLNRqumpbJHx4nbV6lviHZa6L9weOLHm_zyHOrvM0_uThEvKd7kP0XlLG6MRyjHaEhTHW1RMNPOIHX2ygZimNmzeNgwwfA7EdvmI9PacdPQufaUnwMDRqsBcG7m3049GhXI9Fp7sDtD_JKcnX40il3OhwVsfF_9kY61xTCtMuDhScacEg4J1MsOvkoTyXlY1TiUmgzUzBI_uO9OvXeeKpIenj5xPyrRXmuyE-uNx46qj1kLtNmHSk5FYg21YumK67Xcbj0MZ7UnVYh6dy3NKZLBDBAT0lgKOJb_Qz65BJgUveX9zx6alCx5ZZCJsCWtejzha38jxS8soHgG4G1Rsv-2BHMe0718hP1KRYyQvJuKsXLTZEykTviY_e4ih44hMb20BystACdOhc_dEwl-LBaAZQ2Z527mEdPuISThuO3Y6gX7ndtJbQV_rSsLI1hxikjiRFeVMt4IjQ';
    */
};

export const refreshTokenSelector = () => {
    return get(JSON.parse(getCookie(USER_DATA_STORAGE_KEY)), REFRESH);
};

export const emailSelector = (state) => {
    return get(state, [GET_LOGGED_IN_USER, DATA, 'email'], '');
};
export const isSuperAdminSelector = (state): boolean => {
    return get(state, [GET_LOGGED_IN_USER, DATA, 'is_super_admin'], false);
};
export const scopesSelector = (state) => {
    return get(state, [GET_LOGGED_IN_USER, DATA, SCOPES], []) || [];
};
export const idSelector = (state) => {
    return get(state, [GET_LOGGED_IN_USER, DATA, 'id']);
};

export const userSelector = (state) => {
    return get(state, [GET_LOGGED_IN_USER, DATA]);
};

export const isLoggedInSelector = () => {
    return !!tokenSelector();
};

export const getUsersSelector = (state) => {
    return get(state, [GET_USERS, DATA, DATA], []);
};
